export const FEATURE_FLAGS = {
  VDA_ACTIONS: "featureFlagVdaActions",
  QUEUE_MANAGER: "featureFlagQueueManager",
  LIVE_MISSIONS: "featureFlagLiveMissions",
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
